/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { AppConfig, DEFAULT_LANGUAGE_CODE } from "@nf/constants";
import HttpBackend from "i18next-http-backend";

const config = {
  load: "languageOnly" as const,
  i18n: {
    locales: [],
    defaultLocale: DEFAULT_LANGUAGE_CODE,
    backend: {
      loadPath: `${AppConfig.TranslationsUrl}/{{lng}}.json`,
    },
  },
  ns: ["translations"],
  use: [HttpBackend],
};

export default config;
